export default "/assets/images/pug.gif?b4cd7867f4c470bda594d29cfba2a891";